var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFab2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1755_35648)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#374DA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.75 41.25V43.75H28.75V41.25C28.75 41.25 28.75 36.25 36.25 36.25C43.75 36.25 43.75 41.25 43.75 41.25ZM40 30C40 29.2583 39.7801 28.5333 39.368 27.9166C38.956 27.2999 38.3703 26.8193 37.6851 26.5355C36.9998 26.2516 36.2458 26.1774 35.5184 26.3221C34.791 26.4668 34.1228 26.8239 33.5983 27.3484C33.0739 27.8728 32.7167 28.541 32.5721 29.2684C32.4274 29.9958 32.5016 30.7498 32.7855 31.4351C33.0693 32.1203 33.5499 32.706 34.1666 33.118C34.7833 33.5301 35.5083 33.75 36.25 33.75C37.2446 33.75 38.1984 33.3549 38.9017 32.6517C39.6049 31.9484 40 30.9946 40 30ZM44 36.325C44.6833 36.9554 45.2342 37.7156 45.6205 38.5611C46.0068 39.4067 46.2208 40.3208 46.25 41.25V43.75H50V41.25C50 41.25 50 36.9375 44 36.325ZM42.5 26.25C42.1223 26.2502 41.747 26.3093 41.3875 26.425C42.1188 27.4737 42.5109 28.7215 42.5109 30C42.5109 31.2785 42.1188 32.5263 41.3875 33.575C41.747 33.6907 42.1223 33.7498 42.5 33.75C43.4946 33.75 44.4484 33.3549 45.1517 32.6517C45.8549 31.9484 46.25 30.9946 46.25 30C46.25 29.0054 45.8549 28.0516 45.1517 27.3484C44.4484 26.6451 43.4946 26.25 42.5 26.25ZM30 32.5H26.25V28.75H23.75V32.5H20V35H23.75V38.75H26.25V35H30V32.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1755_35648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFab2);
export default __webpack_public_path__ + "static/media/FAB2.55c30aa7f13c2a47441e91e6c37185ee.svg";
export { ForwardRef as ReactComponent };